<div class="container">
  <h5 class="mt-3">Transfer</h5>
  <p class="mt-3">You can make your order payment by transfer to the account details</p>
  <div class="mt-5">
    <p>Account Name</p>
    <h5 class="payment-data">{{transferDetails && transferDetails.account_name}}</h5>
  </div>
  <div class="mt-3">
    <p>Account Number</p>
    <h5 class="payment-data">{{transferDetails && transferDetails.account_number}}</h5>
  </div>
  <div class="mt-3">
    <p>Bank Name</p>
    <h5 class="payment-data">{{transferDetails && transferDetails.bank_name}}</h5>
  </div>
  <div class="mt-3">
    <p>Amount</p>
    <h5 class="payment-data">{{transferDetails && transferDetails.amount | currency: '₦'}}</h5>
  </div>
  <button class="btn btn-primary btn-block mt-5" (click)="initiatePayment('transfer')">Confirm Payment</button>
</div>
